import React, { useState, useEffect } from 'react';
import { FaEye, FaTrash } from 'react-icons/fa';
import MarcaDetailModal from './MarcaDetailModal';
import { get, del } from '../../../helpers/apiHelper';

const MarcasList = () => {
    const [marcas, setMarcas] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [showDetailModal, setShowDetailModal] = useState(false);
    const [selectedMarca, setSelectedMarca] = useState(null);

    useEffect(() => {
        fetchMarcas();
    }, []);

    const fetchMarcas = async () => {
        try {
            setLoading(true);
            const data = await get('marcas/admin');
            setMarcas(data);
        } catch (err) {
            setError(err.message);
        } finally {
            setLoading(false);
        }
    };

    const handleDelete = async (marcaId) => {
        if (!window.confirm('¿Estás seguro de que deseas eliminar esta marca? Esta acción no se puede deshacer.')) return;

        try {
            await del(`marcas/${marcaId}`);
            await fetchMarcas(); // Refresh the list
        } catch (err) {
            setError(err.message);
        }
    };

    const handleViewDetails = (marca) => {
        setSelectedMarca(marca);
        setShowDetailModal(true);
    };

    const handleCloseModal = () => {
        setShowDetailModal(false);
        setSelectedMarca(null);
    };

    if (loading) return <div className="text-center p-4">Cargando...</div>;
    if (error) return <div className="text-red-500 p-4">{error}</div>;

    return (
        <div className="container mx-auto p-4">
            <div className="mb-6">
                <h2 className="text-2xl font-bold">Gestión de Marcas</h2>
            </div>

            <div className="overflow-x-auto bg-white rounded-lg shadow">
                <table className="min-w-full table-auto">
                    <thead className="bg-gray-50">
                        <tr>
                            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Nombre</th>
                            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Rubro</th>
                            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Puntos/Ticket</th>
                            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Tiendas</th>
                            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Clientes</th>
                            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Acciones</th>
                        </tr>
                    </thead>
                    <tbody className="bg-white divide-y divide-gray-200">
                        {marcas.map((marca) => (
                            <tr key={marca._id} className="hover:bg-gray-50">
                                <td className="px-6 py-4 whitespace-nowrap">
                                    <div className="flex items-center">
                                        {marca.logotipo && (
                                            <img
                                                src={marca.logotipo.cdnUrl}
                                                alt={marca.nombre}
                                                className="h-8 w-8 mr-3 rounded-full"
                                            />
                                        )}
                                        <div className="text-sm font-medium text-gray-900">{marca.nombre}</div>
                                    </div>
                                </td>
                                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                                    {marca.rubro || 'No especificado'}
                                </td>
                                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                                    {marca.puntosTicket}
                                </td>
                                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                                    {marca.tiendas?.length || 0}
                                </td>
                                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                                    {marca.clientes?.length || 0}
                                </td>
                                <td className="px-6 py-4 whitespace-nowrap text-sm font-medium">
                                    <div className="flex space-x-3">
                                        <button
                                            onClick={() => handleViewDetails(marca)}
                                            className="text-blue-600 hover:text-blue-900"
                                            title="Ver detalles"
                                        >
                                            <FaEye className="h-5 w-5" />
                                        </button>
                                        <button
                                            onClick={() => handleDelete(marca._id)}
                                            className="text-red-600 hover:text-red-900"
                                            title="Eliminar marca"
                                        >
                                            <FaTrash className="h-5 w-5" />
                                        </button>
                                    </div>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>

            {showDetailModal && (
                <MarcaDetailModal
                    marca={selectedMarca}
                    onClose={handleCloseModal}
                />
            )}
        </div>
    );
};

export default MarcasList; 